import React, {useEffect, useState} from 'react';
import {useReactFlow} from "@xyflow/react";
import {FaTimes} from "react-icons/fa";
import {useEdgeBuilder} from "../../association-network-context.jsx";
import Button from "../../../../../../components/button/button.jsx";
import InputForm from "../../../../../../components/input/input-form.jsx";

const colors = [
    {value: "#b1b1b7", label: "Cinza"},
    {value: "#0000ff", label: "Azul"},
    {value: "#008000", label: "Verde"},
    {value: "#ff0000", label: "Vermelho"}
]

const sizes = [
    {value: 1, label: "1"},
    {value: 2, label: "2"},
    {value: 3, label: "3"},
    {value: 4, label: "4"},
    {value: 5, label: "5"},
]

const AddEdge = ({show, setUndoDisabled}) => {
    const [observation, setObservation] = useState("")
    const [color, setColor] = useState("")
    const [size, setSize] = useState(1)
    const {getEdges, setEdges, getNodes} = useReactFlow();
    const {setNewEdge, setPanelOpened} = useEdgeBuilder();
    const [isEditing, setIsEditing] = useState(false);

    useEffect(() => {
        if (show) {
            const selectedEdge = getEdges().find(e => e.selected);
            if (selectedEdge) {
                const {data, style} = selectedEdge
                setObservation(data?.label || "")
                setColor(style?.stroke || "#b1b1b7")
                setSize(style?.strokeWidth || 1)

                setIsEditing(!!data?.label);
            } else {
                setObservation("")
                setColor("#b1b1b7")
                setSize(1)
            }
        }
    }, [show]);

    const save = () => {
        const selectedEdge = getEdges().find(e => e.selected);
        if (selectedEdge) {
            setEdges((edges) =>
                edges.map((e) => e.id === selectedEdge.id ?
                    {
                        ...e,
                        data: {label: observation},
                        style: {
                            stroke: color,
                            strokeWidth: size,
                        },
                        selected: false
                    } : e)
            );
        } else {
            const nodeSelected = getNodes().find(n => n.selected);
            setNewEdge({
                id: null,
                source: nodeSelected.id,
                target: null,
                type: "floating",
                updatable: true,
                data: {label: observation},
                style: {
                    stroke: color,
                    strokeWidth: size,
                }
            });
        }
        setUndoDisabled(false)
        setPanelOpened(null)
    }

    return (
        <div
            className={`absolute top-0 inset-0 flex items-center justify-center bg-[#33333330] ${show ? "" : "hidden"}`}>
            <div className="bg-white rounded-[5px] w-1/4">
                <div className="relative text-[20px] pl-3 pt-1 pb-1 border-b border-[#ddd]">
                    <span>{isEditing ? "Editar" : "Adicionar"} conexão</span>
                    <div onClick={() => setPanelOpened(null)}
                         className={"absolute top-0 right-0 p-[10px] cursor-pointer"}>
                        <FaTimes size={14} color={"#a3a3a3"}/>
                    </div>
                </div>
                <div className={"p-4 grid grid-cols-12 !gap-4"}>
                    <div className={"col-span-12"}>
                        <InputForm
                            value={observation}
                            id="observation"
                            name={"observation"}
                            label="Observação"
                            onChange={({target: {value, id}}) => setObservation(value)}
                        />
                    </div>
                    <div className="col-span-12">
                        <p className={"mb-0"}>Cor</p>
                        <div className={"flex items-center justify-start gap-2"}>
                            {
                                colors.map((c, index) => (
                                    <div key={index}
                                         onClick={() => setColor(c.value)}
                                         className={`w-[30px] h-[30px] cursor-pointer rounded-[3px] ${color === c.value ? "border-2 !border-[#000]" : ""}`}
                                         style={{background: c.value}}></div>
                                ))
                            }
                        </div>
                    </div>

                    <div className="col-span-12">
                        <p className={"mb-0"}>Tamanho</p>
                        <div className={"flex items-center justify-start gap-2"}>
                            {
                                sizes.map((s, index) => (
                                    <div key={index}
                                         onClick={() => setSize(s.value)}
                                         className={`w-[30px] h-[30px] flex justify-center items-center cursor-pointer rounded-[3px] ${size === s.value ? "border-2 !border-[#000]" : "border"}`}>
                                        <div className={"w-full"}  style={{height: (s.value * 2) + "px", background: color}}></div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
                <div className={"border-t border-[#ddd] py-[10px] px-[20px]"}>
                    <div className={"flex justify-end"}>
                        <Button className={""} onClick={save}>
                            {isEditing ? "Editar" : "Adicionar"}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddEdge;